import React, { useEffect, useState } from "react";
import Popup from "./pages/popupfiles/Popup/Popup";
import { uploadApplicationDocuments } from "./HttpRequest/uploadDocuments";
import { updateApplication } from "./HttpRequest/applyapplication";
import { registersuccess } from "./SweetAlert/SweetAlert";

export default function ModelUpload(application,closePopup) {

  const [applicationData, setapplicationData] = useState();
  const [modalActive, setModalActive] = useState(true);
  const [uploads, setUploads] = useState([]);
  const [uploaddoc, setuploaddoc] = useState(false);
  const [identifiers, setIdentifiers] = useState([]);
  const [normalsear, setnormalsear] = useState({
    lor1: true,
    lor2: true,
    sop: true,
    lor3: true,
    lor1name: "",
    lor2name: "",
    lor3name: "",
    sopname: "",
  });
  const [showModal, setShowModal] = useState(false);
  const [applicationId, setapplicationId] = useState();
  const [masterId, setmasterId] = useState("");
  const [fileType, setFileType] = useState("");
  const [Error, setError] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");

  useEffect(() => {
    console.log("Data from the modalpopup====>", application);
    setapplicationData(application.applicationobj);
    setapplicationId(application.applicationobj.applicationId);
  }, [application]);

  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = 0; i < 3; i++) {
    years.push(currentYear + i);
  }
  const currentMonth = new Date().getMonth();
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
    "Spring",
    "Fall",
    "Summer",
  ];

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
  };

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };
  // const documentFiles = [];
  const [documentFiles, setdocumentFiles] = useState([]);

  const handleUpload = (file) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      const uploadInfo = {
        name: file.name,
        type: "File",
        content: reader.result,
      };
      setUploads([...uploads, uploadInfo]);
    };
    reader.readAsDataURL(file);
  };

  const handleFileInputChange = (identifier) => (event) => {
    const files = event.target.files;
    console.log("files", event);
    console.log("files name", identifier);
    console.log("----", files);

    if (identifier === "lor1") {
      const files = event.target.files;
      console.log(files.name);
      setnormalsear({
        ...normalsear,
        lor1: false,
        lor1name: "lor1",
      });
    } else if (identifier === "lor2") {
      setnormalsear({
        ...normalsear,
        lor2: false,
        lor2name: "lor2",
      });
    } else if (identifier === "sop") {
      setnormalsear({
        ...normalsear,
        sop: false,
      });
    } else if (identifier === "lor3") {
      setnormalsear({
        ...normalsear,
        lor3: false,
        lor3name: "lor3",
      });
    }
    if (files && files.name) {
      const fileName = files.name;
      const lastDotIndex = fileName.lastIndexOf(".");
      if (lastDotIndex !== -1) {
        const fileExtension = fileName
          .substring(lastDotIndex + 1)
          .toLowerCase();
        console.log(fileExtension);
      } else {
        setError("File has no extension.");
      }
    } else {
      setError("File is undefined or has no name property.");
    }
    setIdentifiers([...identifiers, identifier]);
    console.log(fileType);
    for (let i = 0; i < files.length; i++) {
      handleUpload(files[i]);
    }
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        documentUploadMethod(files[i], identifier);
      }
    }
  };

  const [pagedata, setPageData] = useState();
  const handlechange = (event) => {
    console.log("Event:", event);
    if (event && event.target) {
      const { value, name } = event.target;
      console.log("Value:", value);
      console.log("Name:", name);
      setcourseName((prevCourseName) => ({
        ...prevCourseName,
        [name]: value,
      }));
    }
  };
  const handleWriteClick = async () => {};

  const removethefile = (index) => {
    const updatedUploads = [...uploads];
    updatedUploads.splice(index, 1);
    setUploads(updatedUploads);
  };
  const downloadFile = (index) => {
    const fileToDownload = uploads[index];
    const downloadLink = document.createElement("a");
    downloadLink.href = fileToDownload.url;
    downloadLink.download = fileToDownload.name;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };
  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const onChange = (value) => {
    console.log(`selected ${value}`);
  };
  const onSearch = (value) => {
    console.log("search:", value);
  };
  const documentUploadMethod = (file, type) => {
    console.log("dum file ", file, type);
    const formData = new FormData();
    console.log("file name-->", formData);
    formData.append("file", file);

    const existingDocumentIndex = documentFiles.findIndex(
      (doc) => doc.type === type
    );
    if (existingDocumentIndex !== -1) {
      documentFiles[existingDocumentIndex] = {
        file: formData,
        type: type,
      };
    } else {
      let fileObj = {
        file: formData,
        type: type,
      };
      documentFiles.push(fileObj);
    }

    console.log("files added-->", documentFiles);
  };

  const submitApplyFinalDoccuments = async (data) => {
    console.log("...", documentFiles);
    if (documentFiles.length > 0) {
      try {
        const uploadPromises = documentFiles.map(async (doc) => {
          try {
            let userId = localStorage.getItem("id");
            console.log("appli Id -->", applicationId);
            console.log("application--->",applicationData)
            const response = await uploadApplicationDocuments(
              userId,
              data.applicationId,
              doc.type,
              doc.file
            );
            console.log("file upload res-->", response);
            return response;
          } catch (error) {
            console.error("Error uploading file:", error);
            throw error;
          }
        });
        const responses = await Promise.all(uploadPromises);
        console.log("data from the component===>",data);
        let updatedData={
          ...data,         
          subStatus:"apply",
          intake:selectedMonth,
          year:selectedYear,
        }
        console.log("Updated Id",updatedData);
        updateApplication(updatedData.id,updatedData).then((response) =>{
          console.log("update from the component===>",response.data.applicationId);
          registersuccess("Application submitted successfully with applicationId   "+response.data.applicationId)
          setdocumentFiles([]);
          setModalActive(false);
          closePopup(false)      

        })
      } catch (error) {
        console.error("Error uploading files:", error);
      }
    } else {
      console.log("No document is selected");
    }
  };

  const closeModal = () => {
    setShowModal(false);
    console.log("close");
  };
  const openModal = () => {
    setShowModal(true);
    console.log("open");
  };

  return (
    <div>
      {uploaddoc ? (
        <></>
      ) : (
        <>
          <Popup active={modalActive} setActive={setModalActive}>
            <div className="model">
              <div className="modal-dialog w-100 m-0 modal111">
                <div className="modal-content modal-contentnormal">
                  <div className="modal-body">
                    <p>
                      <strong>Upload Document </strong>
                    </p>
                    <span className="" style={{ fontSize: "12px" }}>
                      <strong>
                        Submit the documents to apply for the selected program
                      </strong>
                    </span>
                    <div className="mt-1">
                      <div className="normalsearch-cen">
                        {normalsear.sop && (
                          <div className="card  normalsearchcard">
                            <strong>
                              {" "}
                              <span>SOP</span>
                            </strong>
                            <div>
                              <label className="imagedocument documen btn btn btn-success mt-2  normalbtn-success">
                                <input
                                  type="file"
                                  onChange={handleFileInputChange("sop")}
                                  multiple
                                  style={{ display: "none" }}
                                />
                                Upload{" "}
                                <i
                                  class="fa-solid fa-arrow-up-from-bracket"
                                  style={{ marginLeft: "8px" }}
                                ></i>
                              </label>
                            </div>
                          </div>
                        )}
                        {normalsear.lor1 && (
                          <div className="card  normalsearchcard">
                            <strong>
                              {" "}
                              <span>LOR1</span>
                            </strong>
                            <div>
                              <label className="imagedocument documen btn btn btn-success mt-2  normalbtn-success">
                                <input
                                  type="file"
                                  onChange={handleFileInputChange("lor1")}
                                  multiple
                                  style={{ display: "none" }}
                                />
                                Upload{" "}
                                <i
                                  class="fa-solid fa-arrow-up-from-bracket"
                                  style={{ marginLeft: "8px" }}
                                ></i>
                              </label>
                            </div>
                          </div>
                        )}
                        {normalsear.lor2 && (
                          <div className="card  normalsearchcard">
                            <strong>
                              {" "}
                              <span>LOR2</span>
                            </strong>
                            <div>
                              <label className="imagedocument documen btn btn btn-success mt-2  normalbtn-success">
                                <input
                                  type="file"
                                  onChange={handleFileInputChange("lor2")}
                                  multiple
                                  style={{ display: "none" }}
                                />
                                Upload{" "}
                                <i
                                  class="fa-solid fa-arrow-up-from-bracket"
                                  style={{ marginLeft: "8px" }}
                                ></i>
                              </label>
                            </div>
                          </div>
                        )}
                        {normalsear.lor3 && (
                          <div className="card  normalsearchcard">
                            <strong>
                              {" "}
                              <span>LOR3</span>
                            </strong>
                            <div>
                              <label className="imagedocument documen btn btn btn-success mt-2  normalbtn-success">
                                <input
                                  type="file"
                                  onChange={handleFileInputChange("lor3")}
                                  multiple
                                  style={{ display: "none" }}
                                />
                                Upload{" "}
                                <i
                                  class="fa-solid fa-arrow-up-from-bracket"
                                  style={{ marginLeft: "8px" }}
                                ></i>
                              </label>
                            </div>
                          </div>
                        )}
                      </div>
                      {uploads.map((upload, index) => (
                        <div key={index} className="uplaoddocnormal mt-3">
                          <div className="uploadcardiamges">
                            {upload.name.toLowerCase().endsWith(".png") && (
                              <img
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADgCAMAAADCMfHtAAAAw1BMVEX/////AAAAAAD/MTH/fn4eHh48PDzAwMC9vb3/19f/GRnZ2dnd3d34+Pj/m5v/e3u0tLT/DQ3/OzvqAAC4AAD/3d3/oKD/5OT/dXX/7u7/zs7/9PT/UVH/V1f/kJD/q6vu7u7/Rkb/vLz/8PD/xsb/YWGoqKgODg6SkpJ0dHQ1NTVdXV1VVVVlZWX/p6f/urqdnZ3Ozs5GRkYdHR34JSX/ior/YGD/QkJxcXGDg4MsLCxMTEyvt7f/Vlb/ISH/bGznX1/EHRPWAAAITklEQVR4nO2daWPaOBCGRSFpoBBCdwmHU64QmhNyX90m/f+/aoEEkDQ6LFvyyFTvtyLbmieSdcyMXEKUqk7OLnaz08XLjdoe26pefMlc59UMASfZ8y2UHeI1DmB2iF+xADNDxAPMCPEUkzATxFdUwi8D54ADXMAMEG+wCZ0jIo6kn/rpGBGf0HUr+kDothV9IHSLyBKeOqxpoaoE8a7mrk6W8Ku7ipaSEbpEZAn3nNXzISnhlx1niHiEP1nEV1eIeIRn3IrYVSviEV6Ql0xaEY/wkpCzLBDxCG8JQDx3USce4e7ihwwQ8Qhfl788s4i79uvEI9z5+IlDvLVeJ+J8+PnblWNExDXN6kcO8ZflOj0gJJzH3TKiD4Q84qXVOr0gJJcOEf0g5BEvLNbpCSH55QwRkZBdhd6yiFfW6vSG0BkiIuGAK9x1g+gRIY/4bKdOnwjJuQtEREIYWatxiGc26vSKkNS4WJ8NRL8ISW3HOqJnhADxJXWdiITfhJfUOD9qakREQklaVO3OLqJ/hKTGEqZFRCSUhoEGVjsqIqG8Mj59IlXQD5HwQH6dTUQ/CQHidfI6EQknqivtIfpKCIKpiRG9JQSImsulQiTUtYolRERC7SbeDmK2hOz4oU295BFVo69U2RKyC7K7ge76bxYQsyXks1nPJnt7X2++VQeDmjjCbQExY0IuWkjr58757u3l1dnL6fX15GDBXR3UQEc1tzBjwj05oQyc+7fxUZSMCS3kzZvWmDVh+sMdpo2YNSHhe52xTG3MnDB1Yrn3bZj6gIfYgSVX9oR8ltAWEqZsxTwQkps0w00uCAmZ3Ens3xrC+Yrz9JcEYVsIl6rFETnIMWE8BUK1AqEPCoRqBUIfFAjVCoQ+KBCqFQh9UCBU628jdH3SOZn+Y2zUxuRavcdhcaP7f2jdF30UayNdMvzx0OX4RsXCtqnRp/ii39jmONFTZ91BsU1xpuYHYAfbDof6aMXtewU3Ki4Ap9hWONV0TtjANsKpGoR0sW1wrC7pYZvgWD1yhG2CYx2Re2wTHOueYFvgXIEw/wqE+VcgzL8CYf4VCPOv3BA23iqNyluCzWxCwkaFF103KJReGUNv9f64dRyt3IJRpzt7+GFwf0LCQ+BRLlGlTZ37OWqOek9x6nmfdcRP6PTjUiYk3AdV1qnSso5wqeNpRV3J0yxS3d+Jt3lHJJyrr+Lj/fJQ0bv3hCQaymqYxbp/5D0hISfC5x8p+yellnbcQickohGjFP92rccen1DgsO2Z3K6LunhAOE4FqB6u/CDkHZpts7sJefSekG3E76aAmlfRB0L2TWwZE5IHDwi7S5WPxRbWlU9eKiqPZqOxhP7YA8J10bAPygiZbW5tCBHGqzB85UG4Tm3jE1L9sAhP9lIDvmgp02EW6aKRVhVAy56wcARKI8oeqCZX94ngGr8IC2O5gQ/QeDij1/krRvuK+BIGIZzw1sWCoUSwxVo/Pyr3S981pmIQPoHiVRMI5kLRTLDo5/OGO9HsL/EIi6B41Q5wFIkKItV1DUcJg/A3KC5KbzxMZh8lDEI4JX4WCCbDWN4cpRAIK5Djs2QICsSd1EjZEzbgqmQ148G5wkIuTNarNuG6c7XDg93XQsJWRoT1udqPpX2x/2y1QYSltBe28PZdLnRCpVry+xh34VTxDPnU6APhuqHgiobZ/kNHe04IN1t0uH1kJovcEm7cLNBJyuS+5pWQcpXBNmRGkJwS0jMenCmH+Scs00+FIw3jKEQmpGeu+ISsN1czH+aQsDlknwo3/0yIEJmQdnfFI+yCsBN8KhM9QyakVx9awqg1EzkAoXuDcdI4JKyclPrjFu3zgoT06gMStimdDGV+I7j5Z8zrdVpr8VNnUsKnk16/uxrh6L0aJKTnZtXeQik4Icri2Pw2JAnhW5P/OykqYBk0e3y54FADQm+f4j3HSQihS0HFwGzGExPynlC56TYI4SqR6jHAEMYxnZhQ4PKWNKIVQrDC2Pi9fgBDmGE9OSHsppKoi433EAZJNj0RGrJvhxD+6cTZGnUrYylMiFj1mEdoBpNRkZxQGB8Fbu93eFUiQoHXb1wUo3PTQQpCwVgzX54P6Ut6ohBisvlQlIDXHHdFyTxsBCwFoWAHtXx+bwFZGb4fStZLyQgNsj5Y53saQlF0MIaSEYojzkKxN6YhFA2nzggFKxeJZux9qQgF3hp3hIKxRqw3m4QwCq6XIvVLvSaO+SbWudvSEZonRSljcJpVvzafeSGQ5JmSUDxlyNVSxkt1+xpJmjUtGB9KS1h4N+CL+B5kSFjRvveCNN3UhIVi7NwvbZBYvzfVuCREmQTpCaXZX5z29Q+KsftW1dUVfnLCBmGhMtV1n1asZP1Y/oW+pK6m5MyDFcK56qr+M4p5zj6mB+URnuzoTKWJSLMmr8SfpqiPBX/dzjjeeZSl4nsTi6XpuNnqRJ3jTrPcb2d3jv/td2+/Py4v1B33e+9PsRKF1srNya7ECoT5VyDMvwJh/hUI869AmH9t+efaFi7Rbf6m4EJFzeG9/Osxjh8g1zoEp4q2TS0u/W/rtHCgb/enIZeeHtXxxLzrM5i7vRPG+oiKyede8iQq72E7P2LKuLKj7XsZ28DR2u33Shv9+ZfWn5KPYm1sUyUPU/3Hbbbwfw7g9Lf97w+BEEeBUK1A6IMCoVqB0AcFQrUCoQ8KhGr9bYR+7p5sEp46sTCtLi0S5kGBMBD6L1M/zQ22wcYaGBIOsA02liEgIa/YFhvqypjwGttkQyVYlGCbbKZdc8CcjaamI+lSp9hWGyjh1iA/r2LinUH1Uv9wD/Q8SAq4YJxc7d7t+Ku72+cDDd//IagBSlujXbAAAAAASUVORK5CYII="
                                alt="xlimages"
                                className="normalxlimage"
                              />
                            )}

                            {upload.name.toLowerCase().endsWith(".jpeg") && (
                              <img
                                src="https://static.vecteezy.com/system/resources/previews/003/399/528/non_2x/modern-flat-design-of-jpeg-file-icon-for-web-free-vector.jpg"
                                alt="xlimages"
                                className="normalxlimage"
                              />
                            )}

                            {upload.name.toLowerCase().endsWith(".jpg") && (
                              <img
                                src="data:image/png;base64,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"
                                alt="xlimages"
                                className="normalxlimage"
                              />
                            )}
                            {upload.name.toLowerCase().endsWith(".pdf") && (
                              <img
                                src="https://www.pngguru.in/storage/uploads/images/PDF%20Icon%20free%20png_1695284057_1717843005.jpg"
                                alt="xlimages"
                                className="normalxlimage"
                              />
                            )}
                          </div>
                          <div
                            onClick={() => handleFileInputChange("fileInputLor3")}
                            className="uploadtext"
                          >{`Added ${upload.type} - ${upload.name}`}</div>
                          <div className="uploadbuttongroup">
                            <i
                              class="fa-solid fa-download"
                              onClick={() => downloadFile(index)}
                            ></i>
                            <i class="fa-regular fa-pen-to-square"></i>
                            <i
                              class="fa-solid fa-trash"
                              onClick={() => removethefile(index)}
                            ></i>
                            <button className="btn btn-primary btnbuttondoc">
                              {identifiers[index]}
                            </button>
                          </div>
                        </div>
                      ))}
                      <div className="normalsearch-model-button">
                        <p style={{ marginBottom: "0px", marginRight: "9px" }}>
                          <strong>Choose Intake, Year: </strong>
                        </p>
                        <select
                          id="monthSelect"
                          name="month"
                          className="form-control"
                          value={selectedMonth}
                          onChange={handleMonthChange}
                        >
                          <option value="">Select Month</option>
                          {monthNames.map((month, index) => (
                            <option key={index} value={month}>
                              {month}
                            </option>
                          ))}
                        </select>
                        <select
                          id="yearSelect"
                          name="year"
                          className="form-control"
                          value={selectedYear}
                          onChange={handleYearChange}
                        >
                          <option value="">Select Year</option>
                          {years.map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer  modal-footer1">
                    <div className="imagedocument">
                      {" "}
                      <button
                        type="button"
                        className="bbtn btn-secondary footerbutton footerbutton3"
                        onClick={closeModal}
                      >
                        Cancel
                      </button>
                    </div>
                    <label className="imagedocument documen documen1">
                      <input
                        type="file"
                        onChange={handleFileInputChange}
                        multiple
                        style={{ display: "none" }}
                      />
                      Add Other document{" "}
                      <i className="fa-solid fa-file-import"></i>
                    </label>
                    {applicationData&&(
                    <button
                      type="button"
                      className="btn btn-secondary footerbutton"
                      onClick={()=>submitApplyFinalDoccuments(applicationData)}
                    >
                      Apply
                    </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Popup>
          {showModal && (
            <div className="modal">
              <div className="overlay">
                <div className="modal-dialog">
                  <div className="modal-content modal-contentnormal">
                    <div className="modal-body">
                      <div className="mt-1">
                        <div className="uplaoddocnormal mt-3 ">
                          <div className="uploadcardiamges">
                            <i class="fa-solid fa-file fs-3"></i>
                          </div>
                          <div
                            className="uploadtext"
                            onClick={handleFileUpload}
                          >
                            <strong
                              style={{ color: "gray", cursor: "pointer" }}
                            >
                              Add Statement Of PurPose - SOP
                            </strong>
                          </div>
                          <div className="">
                            <i
                              class="fa-solid fa-upload"
                              style={{ marginRight: "0.3rem" }}
                            ></i>
                          </div>
                          <input
                            type="file"
                            id="fileInput"
                            style={{ display: "none" }}
                            onChange={(event) =>
                              documentUploadMethod(event, "sop")
                            }
                          />
                        </div>

                        <div className="uplaoddocnormal mt-3 ">
                          <div className="uploadcardiamges">
                            <i class="fa-solid fa-file fs-3"></i>
                          </div>
                          <div className="uploadtext">
                            <strong>
                              Add Letter Of Recommendation - LOR01
                            </strong>
                          </div>
                          <div className="">
                            <i
                              class="fa-solid fa-upload"
                              style={{ marginRight: "0.3rem" }}
                            ></i>
                          </div>
                        </div>

                        <div className="uplaoddocnormal mt-3 ">
                          <div className="uploadcardiamges">
                            <i class="fa-solid fa-file fs-3"></i>
                          </div>
                          <div className="uploadtext">
                            <strong>
                              Add Letter Of Recommendation - LOR02
                            </strong>
                          </div>
                          <div className="">
                            <i
                              class="fa-solid fa-upload"
                              style={{ marginRight: "0.3rem" }}
                            ></i>
                          </div>
                        </div>
                        <div className="uplaoddocnormal mt-3 ">
                          <div className="uploadcardiamges">
                            <i class="fa-solid fa-file fs-3"></i>
                          </div>
                          <div className="uploadtext">
                            <strong>
                              Add Letter Of Recommendation - LOR03
                            </strong>
                          </div>
                          <div className="">
                            <i
                              class="fa-solid fa-upload"
                              style={{ marginRight: "0.3rem" }}
                            ></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    {uploads.map((upload, index) => (
                      <div key={index} className="uplaoddocnormal mt-3">
                        <div className="uploadcardiamges">
                          <i className="fa-solid fa-file fs-3"></i>
                        </div>
                        <div className="uploadtext">
                          <strong>{`Add ${upload.type} - ${upload.name}`}</strong>
                        </div>
                        <div>
                          <i
                            className="fa-solid fa-upload"
                            style={{ marginRight: "0.3rem" }}
                          ></i>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="modal-footer  modal-footer1">
                  <div className="imagedocument">
                    <i class="fa-regular fa-image"></i> Photos
                  </div>
                  <label className="imagedocument documen documen1">
                    <input
                      type="file"
                      onChange={handleFileInputChange}
                      multiple
                      style={{ display: "none" }}
                    />
                    Add document <i className="fa-solid fa-file-import"></i>
                  </label>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeModal}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
